import {ErrorHandler, Injectable} from '@angular/core';

import Bugsnag from '@bugsnag/js';
import {Client} from '@bugsnag/core';

import {environment} from '../../../environments/environment';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private readonly bugsnagClient: Client;

    constructor() {
        /**
         * Init bugsnag client if needed.
         */
        if (environment.useBugsnag && environment.bugsnagApiKey) {
            this.bugsnagClient = Bugsnag.start({
                apiKey: environment.bugsnagApiKey,
                releaseStage: environment.env,
                redactedKeys: [
                    /^access_token$/i,
                    /^password$/i,
                ]
            });
        }
    }

    handleError(error: any): void {
        /**
         * Only unknown errors.
         */
        if (environment.useBugsnag && environment.bugsnagApiKey) {
            this.bugsnagClient.notify(error);
        } else {
            console.error('Unhandled exception: ', error);
        }
    }
}
